import { useEffect } from 'react';
import { arrayOf, shape } from 'prop-types';
import { Route } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { config } from 'ENV_CONFIG';
import useExperiences from '~/monetate-experience/hooks/useExperiences';
import { RouteRender } from '~/components';

export const RouterOutlet = ({ routes }) => {
  const { location } = config?.history || {};
  const { getMonetateExperiences, handleMonetateCampaigns } = useExperiences();
  const isPageLoaded = useSelector((state) => state.loader.isCallFinished);
  const experiences = useSelector((state) => state.experiences.monetateExperiences);

  useEffect(() => {
    const canLoadCampaigns = isPageLoaded && experiences?.length;
    if (canLoadCampaigns) {
      handleMonetateCampaigns(experiences);
    }
  }, [isPageLoaded]);

  useEffect(() => {
    getMonetateExperiences();
  }, [location]);

  return (
    <RouteRender>
      {routes.map(({ key, ...route }) => (
        <Route key={key} {...route} />
      ))}
    </RouteRender>
  );
};

RouterOutlet.propTypes = {
  routes: arrayOf(shape({})).isRequired,
};
